<template>
    <div>
        <vk-offcanvas-content>
            <vk-offcanvas :show.sync="show">
                <vk-offcanvas-close @click="show = false"></vk-offcanvas-close>
                <h3>Report Details</h3>
                <div v-html="parseOutputData()"></div>
            </vk-offcanvas>
        </vk-offcanvas-content>
        <div>
            <b-button @click="show = !show" style="background-color:#1a93ca; color:white; border: none" type="primary">View</b-button>
        </div>
    </div>
</template>

<script>
import { Offcanvas, OffcanvasClose, OffcanvasContent } from "vuikit/lib/offcanvas";
import { Button } from 'vuikit/lib/button';

export default {
    name: "ShowIncludesContent",
    components: {
        "vk-offcanvas": Offcanvas,
        "vk-offcanvas-close": OffcanvasClose,
        "vk-offcanvas-content": OffcanvasContent,
        "vk-button": Button,
    },
    props: {
        row: { required: true},
        field: { required: true}
    },
    data(){
        return {
            output: {},
            show: false,
        }
    },
    methods: {
        parsePropsValue(){
            this.output = this.row[this.field]
        },

        parseOutputData(){
            let htmlData = `<table class="vgt-table bordered "><tbody>`;
            Object.entries(this.output).forEach(item => {
                htmlData += `
                    <tr>
                        <td class="vgt-left-align"><strong>${item[0]}:</strong></td>
                        <td class="vgt-left-align">${item[1]}</td>
                    </tr>
                `;
            })
            htmlData += `</tbody></table>`;

            return htmlData;
        }
    },
    mounted(){
        this.parsePropsValue();
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyReportComponents/ShowIncludesContent.vue